import React from 'react';
import { Mail, Phone, MapPin, Linkedin } from 'lucide-react';
import { companyInfo } from '../data/mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="dark-footer">
      <div className="footer-content">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-section">
            <img 
              src="https://customer-assets-wrfwihn1.emergentagent.net/job_exim-solutions-2/artifacts/q64g06lc_HSNL%20Advisory%20Luxury%20Logo.png"
              alt="HSNL Advisory – Strategic Transaction Advisory"
              className="footer-logo"
            />
            <p className="footer-text">Strategic Transaction Advisory</p>
            <p className="footer-text-small">Real Estate • Capital Advisory • Global Trade</p>
            <p className="footer-text-small" style={{marginTop: '12px'}}>HSNL Advisory - Registered in India</p>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4 className="footer-subheading">Services</h4>
            <ul className="footer-links">
              <li><a href="/services/real-estate" className="footer-link">Real Estate Advisory</a></li>
              <li><a href="/services/investment-finance" className="footer-link">Investment & Finance</a></li>
              <li><a href="/services/international-trade" className="footer-link">International Trade</a></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-subheading">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="/active-mandates" className="footer-link">Active Mandates</a></li>
              <li><a href="/strategic-opportunities" className="footer-link">Strategic Opportunities</a></li>
              <li><a href="/global-network" className="footer-link">Global Network</a></li>
              <li><a href="/investor-network" className="footer-link">Investor Network</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-section">
            <h4 className="footer-subheading">Contact Us</h4>
            <ul className="footer-contact">
              <li className="footer-contact-item">
                <Mail size={18} />
                <a href={`mailto:${companyInfo.email}`} className="footer-link">
                  {companyInfo.email}
                </a>
              </li>
              <li className="footer-contact-item">
                <Phone size={18} />
                <a href={`tel:${companyInfo.phone}`} className="footer-link">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="footer-contact-item">
                <MapPin size={18} />
                <span className="footer-text-small">{companyInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} HSNL Advisory. All rights reserved. | HSNL Advisory - Registered in India
          </p>
          <div className="footer-social">
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link">
              <Linkedin size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
